export default {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  PAPERLINE_BASE_URL: process.env.REACT_APP_PAPERLINE_BASE_URL
}
export const WO_PRELIMINARY = 'A';
export const WO_RELEASED = 'B';
export const ORDER_STATUS_ACTIVE = '4';